// @flow
/** @jsx h */
import { h } from 'preact';
import { route } from 'preact-router';
import style from './style.css';
import SlickSlider from '../../../../../components/common/slickSlider';
import { tracker } from '../../../../../tracking';
import { UserActionType } from '../../../../../tracking';

type Props = {
  campaignId: string,
  header: string,
  pageKey: string,
  lenderId: string,
  bicAction: Function,
};

const ProductSlider = ({ pageKey }: Props) => {
  const sliderSettings = {
    dots: true,
    speed: 500,
    rows: 1,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    placeholders: false,
    swipeToSlide: true,
    mobileFirst: true,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
          nextArrow: null,
          prevArrow: null,
          arrows: true,
          infinite: true,
        },
      },
    ],
  };
  const products = [
    {
      productLogoIcon: 'https://iccdn.in/img/redmi-note-11-blue.png',
      text: 'Redmi Note 11 4/64',
      url:
        'https://www.zebrs.com/products/redmi-note-11-horizon-blue-4gb-ram-64gb-storage',
    },
    {
      productLogoIcon: ' https://iccdn.in/img/redmi-note-11-space-black.png',
      text: 'Redmi Note 11 4/64',
      url:
        'https://www.zebrs.com/products/redmi-note-11-space-black-4gb-ram-64gb-storage',
    },
    {
      productLogoIcon:
        ' https://iccdn.in/img/redmi-note-11-space-black-6gb.png',
      text: 'Redmi Note 11 6/128',
      url:
        'https://www.zebrs.com/products/redmi-note-11-space-black-6gb-ram-128gb-storage',
    },
    {
      productLogoIcon: ' https://iccdn.in/img/redmi-note-11-pro-black.png',
      text: 'Redmi Note 11 pro 6/128',
      url:
        'https://www.zebrs.com/products/redmi-note-11-pro-stealth-black-6gb-ram-128gb-storage',
    },
    {
      productLogoIcon: ' https://iccdn.in/img/xiaomi-11t-pro-5g-white-8gb.png',
      text: 'Xiaomi 11T pro 5g 8/128',
      url:
        'https://www.zebrs.com/products/xiaomi-11t-pro-5g-moonlight-white8gb-ram128gb-storage',
    },
    {
      productLogoIcon: ' https://iccdn.in/img/xiaomi-11t-pro-5g-magic.png',
      text: 'Xiaomi 11T pro 5g 8/256',
      url:
        'https://www.zebrs.com/products/xiaomi-11t-pro-5g-celestial-magic8gb-ram256gb-storage',
    },
    {
      productLogoIcon: ' https://iccdn.in/img/xiaomi-pro-5g-white-12gb.png',
      text: 'Xiaomi 11T pro 5g 12/256',
      url:
        'https://www.zebrs.com/products/xiaomi-11t-pro-5g-moonlight-white12gb-ram256gb-storage',
    },
    {
      productLogoIcon: ' https://iccdn.in/img/redmi-note-11-pro-starblue.png',
      text: 'Redmi Note 11 pro 8/128',
      url:
        'https://www.zebrs.com/products/redmi-note-11-pro-star-blue-8gb-ram-128gb-storage',
    },
    {
      productLogoIcon: ' https://iccdn.in/img/redmi-note-pro-plus-5g-white.png',
      text: 'Redmi Note 11 pro plus 5g 6/128',
      url:
        'https://www.zebrs.com/products/redmi-note-11-pro-plus-5g-128-storage-phantom-white-6-gb-ram',
    },
  ];

  return (
    <div className={style.productSliderContainer}>
      <SlickSlider setting={sliderSettings}>
        {products.map((itm, index) => {
          return (
            <div className={style.outerProductDetailsContainer}>
              <div className={style.productDetailsContainer}>
                <img
                  src={itm.productLogoIcon}
                  className={style.productIcon}
                  alt='product-logo'
                />
                <div>
                  <div className={style.productNameText}>{itm.text}</div>
                  <div
                    className={style.shopNowText}
                    onClick={() => {
                      tracker.trackUserInteraction(
                        UserActionType.CLICK,
                        'shop_zebrs',
                        pageKey,
                        { productName: itm.text, productUrl: itm.url },
                      ),
                        window.open(itm.url);
                    }}>
                    Shop Now ››
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </SlickSlider>
    </div>
  );
};

export default ProductSlider;

export function SampleNextArrow(props) {
  const { className, propStyle, onClick } = props;
  const customeStyle = {
    display: 'flex',
    position: 'absolute',
    right: '-50px',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    width: '50px',
    height: '50px',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #c8c8c8',
    borderRadius: '50%',
    cursor: 'pointer',
    background: '#F5F5F5',
  };
  return (
    <div style={{ ...customeStyle, ...propStyle }} onClick={onClick}>
      <span
        class={`material-icons cursorPointer`}
        style={{
          fontSize: '40px',
          color: `${
            className.includes('slick-disabled') ? '#C8C8C8' : '#59C4F0'
          }`,
        }}>
        navigate_next
      </span>
    </div>
  );
}

export function SamplePrevArrow(props) {
  const { className, propStyle, onClick } = props;
  const customeStyle = {
    display: 'flex',
    position: 'absolute',
    left: '-25px',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    width: '50px',
    height: '50px',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #c8c8c8',
    borderRadius: '50%',
    cursor: 'pointer',
    background: '#F5F5F5',
  };
  return (
    <div style={{ ...customeStyle, ...propStyle }} onClick={onClick}>
      <span
        class={`material-icons cursorPointer`}
        style={{
          fontSize: '40px',
          color: `${
            className.includes('slick-disabled') ? '#C8C8C8' : '#59C4F0'
          }`,
        }}>
        navigate_before
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./routes/campaign-preapproved-success/components/campaignLandingProductSection/productSlider/index.js